import adventure from '../assets/home/trvto_adventure.jpg';
import hike from '../assets/home/trvto_hike.jpg';
import island from '../assets/home/trvto_island.jpg';
import twodays from '../assets/home/trvto_two_days.jpg';
import oneday from '../assets/home/trvto_one_day.jpg';
import trek from '../assets/home/trvto_trek.jpg';
import mountains from '../assets/home/trvto_mountains.jpg';
import beach from '../assets/home/trvto_beach.jpg';
import road from '../assets/home/trvto_roadtrip.jpg';
import backpacking from '../assets/home/trvto_backpacking.jpg';
import snow from '../assets/home/trvto_snow.jpg';
import camping from '../assets/home/trvto_camping.jpg';

export const destinationData = [
    {
        id: 1,
        image: adventure,
        title: 'Adventure'
    },
    {
        id: 2,
        image: oneday,
        title: 'One day trips'
    },
    {
        id: 3,
        image: twodays,
        title: 'Two days trips'
    },
    {
        id: 4,
        image: trek,
        title: 'Trek'
    },
    {
        id: 5,
        image: island,
        title: 'Island'
    },
    {
        id: 6,
        image: snow,
        title: 'Snow'
    },

    {
        id: 7,
        image: beach,
        title: 'Beach'
    },
    {
        id: 8,
        image: mountains,
        title: 'Mountains'
    },
    {
        id: 9,
        image: backpacking,
        title: 'Backpacking'
    },
    {
        id: 10,
        image: hike,
        title: 'Hike'
    },
    {
        id: 11,
        image: camping,
        title: 'Camping'
    },
    {
        id: 12,
        image: road,
        title: 'Road trip'
    }
];
